import { Items } from 'components/hmilib/hmiclientbase';
import $ from 'jquery';
import * as React from 'react';
import Table from '../../../Table/Table';
import { IRefs } from '../Graph/Graph';
import './tabletrends.css';

interface Trends {
    group: any;
    pensData: any;
    parentID: string;
    refs: IRefs;
    data: any;
    playStopDisplay: boolean;
    newSeriesPoints: any[];
    callbackSelectPen?: (item: string) => void;
    callbackEnablePen?: (item: string, id: number, state: boolean) => void;
}

interface Item {
    key: string;
    // other properties...
}

const TableTrends = (props: Trends) => {
    const { group, pensData, parentID, refs, callbackSelectPen, callbackEnablePen } = props;

    const [checked, setChecked] = React.useState(['0', '1', '2', '3', '4', '5', '6', '7']);
    //данные в таблице
    const [data, setData] = React.useState<any[]>([]);
    let coloritem = [
        '#00CCFF',
        '#967474',
        '#00cc00',
        '#ffcc00',
        '#ff00ff',
        '#ff0000',
        '#0000ff',
        '#8400ff',
        '#00ff84',
        '#ff8200',
        '#ff0084',
        '#84ffff',
        '#c6c3c6',
        '#84ff00',
        '#ffff84',
        '#ff82ff',
        '#ff8284',
        '#0082ff',
        '#8482ff',
        '#84ff84',
        '#ff8242',
        '#ff82c6',
        '#008284',
        '#848284',
        '#008200',
        '#848200',
        '#840084',
        '#840000',
        '#000084',
        '#420084',
        '#008242',
        '#844100'
    ];
    const [dataTable, setDateTable] = React.useState();

    const handleChecked = (item: any, check: boolean) => {
        // console.log(item, check)
        let itemID = item.id;
        if (!check && checked.includes(item.id)) {
            const updatedChecked = checked.filter((item) => item !== itemID);
            setChecked(updatedChecked);
        } else {
            const updatedChecked = [...checked, itemID];
            setChecked(updatedChecked);
        }

        const value: string = item.tagName.props.children[3] ? item.tagName.props.children[3].toString() : '';

        if (callbackEnablePen) {
            callbackEnablePen(value, itemID, check);
        }
    };

    React.useEffect(() => {
        const iframe = document.getElementById(props.parentID) as HTMLIFrameElement | null;
        if (iframe && iframe.contentWindow) {
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

            $('th.header__trends', iframeDocument).each(function () {
                const th = $(this);
                const thDiv = th.find('.th_div');

                thDiv.css('position', 'relative');
                const resizer = thDiv.find('.resizer');

                if (!resizer.length) {
                    const newResizer = $('<div class="resizer"><div class="resizer_visible"></div></div>');
                    thDiv.append(newResizer);

                    newResizer.on('mousedown', function (event) {
                        event.preventDefault();

                        const initialWidth = th.width();
                        const pageX = event.pageX;
                        const columnIndex = th.index();
                        const table = th.closest('table');

                        $(iframeDocument).on('mousemove', function (event) {
                            if (initialWidth) {
                                const width = initialWidth + (event.pageX - pageX);
                                if (width >= 10) {
                                    th.width(width);
                                    const cells = table.find(`tbody td:nth-child(${columnIndex + 1})`);
                                    cells.width(width);
                                }
                            }
                        });

                        $(iframeDocument).on('mouseup', function () {
                            $(iframeDocument).off('mousemove');
                            $(iframeDocument).off('mouseup');
                        });
                    });
                }
            });
        }
    }, []);

    const handleClickRow = (item: any) => {
        const iframe = document.getElementById(props.parentID) as HTMLIFrameElement | null;
        if (iframe && iframe.contentDocument) {
            const tables: HTMLCollectionOf<HTMLTableElement> = iframe.contentDocument.getElementsByClassName(
                'centum-table'
            ) as HTMLCollectionOf<HTMLTableElement>;

            if (tables.length > 0) {
                const table: HTMLTableElement = tables[0];
                const rows: NodeListOf<HTMLTableRowElement> = table.querySelectorAll('tbody tr');
                let itemId = Number(item.id);

                if (itemId >= 0 && itemId < rows.length) {
                    rows.forEach((row) => row.classList.remove('selected-row'));
                    const targetRow: HTMLTableRowElement = rows[itemId];
                    targetRow.classList.add('selected-row');
                }

                // const value: string = item.tagName.props.children[3] ? item.tagName.props.children[3].toString() : '';
                if (callbackSelectPen) {
                    callbackSelectPen(`${item.tagName.props.children[3]}`);
                }
            }
        }
    };

    const [dataIndex, setDataIndex] = React.useState<number>(7200);

    React.useEffect(() => {
        const echartsInstance = refs.chartRef.current.getEchartsInstance();

        echartsInstance.on('showTip', function (params: any) {
            setDataIndex(params.dataIndex);
        });

        return () => {
            echartsInstance.off('showTip');
        };
    }, []);

    React.useEffect(() => {
        if (props.playStopDisplay)
            setDataIndex((prevState) => {
                return prevState + 1;
            });
    }, [props.data]);

    React.useEffect(() => {
        const updateData = () => {
            const echartsInstance = refs.chartRef?.current.getEchartsInstance();
            let currentOptions = echartsInstance.getOption();

            const newData = data.map((item: any, index: any) => {
                let value;
                let pen = Items[pensData[index].penPath];
                const fullPathToTAG: string = `${pensData[index].DATA}/${pensData[index].TAG}.${pensData[index].PARAM}`;

                // const foundItem = props.data[`${fullPathToTAG}.CV`];
                const foundItem = currentOptions.series[index].data;

                let lower = pen.parameters.LOWLIMIT.CV;
                let upper = pen.parameters.HIGHLIMIT.CV;

                if (dataIndex && foundItem) {
                    if (dataIndex <= foundItem.length) {
                        value = foundItem[dataIndex][1];
                    } else {
                        if (foundItem[foundItem.length - 1]) value = foundItem[foundItem.length - 1][1];
                    }
                }

                return {
                    ...item,
                    lower: lower,
                    upper: upper,
                    value: value
                };
            });

            setData(newData);
        };

        updateData();
    }, [dataIndex]);

    const fetchData = () => {
        if (group) {
            let arrPens = group
                .map((item: any, index: any) => {
                    let pen = Items[pensData[index].penPath];
                    if (pen) {
                        let penPV = pen.parameters.PV;
                        let penUNITS = pen.parameters.UNITS;
                        let penColor = coloritem[index];

                        let unit = penUNITS != undefined ? penUNITS.CV : '';
                        let tagComment = pen.description;
                        let lower = pen.parameters.LOWLIMIT.CV;
                        let upper = pen.parameters.HIGHLIMIT.CV;

                        const fullPathToTAG: string = `${pensData[index].DATA}/${pensData[index].TAG}.${pensData[index].PARAM}`;

                        let value = pen.parameters.DATA.CV;

                        let TagName = (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div
                                    className="color"
                                    style={{
                                        width: '0.75em',
                                        height: '0.75em',
                                        border: ' 0px solid',
                                        borderRadius: '50%',
                                        background: penColor,
                                        marginRight: '0.5em'
                                    }}></div>
                                {index + 1} {fullPathToTAG}
                            </div>
                        );

                        return {
                            id: `${index}`,
                            tagName: TagName,
                            tagComm: tagComment,
                            value: value,
                            unit: unit,
                            lower: lower,
                            upper: upper,
                            penColor: penColor,
                            enable: false
                        };
                    }
                    return null;
                })
                .filter(Boolean);

            setData(arrPens);
        }
    };

    React.useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <div className="table-trends" style={{ height: '100%', width: '100%' }}>
                <Table
                    header={[
                        {
                            type: 'select',
                            width: '30px',
                            label: '',
                            idCol: 'selected',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '250px',
                            label: 'Tag Name',
                            idCol: 'tagName',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '200px',
                            label: 'Tag Comment',
                            idCol: 'tagComm',
                            action: false
                        },
                        {
                            type: 'number',
                            width: '100px',
                            label: 'Value',
                            idCol: 'value',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '70px',
                            label: 'Unit',
                            idCol: 'unit',
                            action: false
                        },
                        {
                            type: 'number',
                            width: '70px',
                            label: 'Lower',
                            idCol: 'lower',
                            action: false
                        },
                        {
                            type: 'number',
                            width: '70px',
                            label: 'Upper',
                            idCol: 'upper',
                            action: false
                        }
                    ]}
                    data={data}
                    checked={checked}
                    onCheck={handleChecked}
                    onClickRow={handleClickRow}
                    width="100%"
                    height="100%"
                    paging={true}
                    cssClassHead="header__trends"
                    cssClassBody="body__trends"
                />
            </div>
        </>
    );
};

export default TableTrends;
